export default (props, traits) => ({
  badgeList: {
    flexWrap: 'wrap',
    display: 'flex'
  }
})
